<template>
    <Layout>
    <div class="max-w-4xl mx-auto text-center pt-8">
      <h1 class="text-3xl text-left pl-4 pb-4">Banquet Hall</h1>
      <p class="text-left pl-4 pb-4">Banquet hall was inaugurated on 24.9.2017. This fully renovated hall is now available on rent for the community members & general public for wedding, parties, engagement and religious events.  With an in-house kitchen, the hall can accommodate approximately 150 people. For details on rates and booking you can mail us on secretary@sglm.in or contact us on +91 99872 40404 or +91 22 2628 3715</p>
      <p class="text-left pl-4 pb-4">Dining hall inauguration was done by Shri Manubhai Sayani family</p>
      <p class="text-left pl-4 pb-4">Marriage hall inauguration was done by Shri Champaklal Sayani Family</p>
      <p class="text-left pl-4 pb-4">Kitchen inauguration was done by Shri Premji Jivan Gadhia family</p>


      <h1 class="text-3xl text-left pl-4 pb-4 pt-4">Banquet Hall Photos</h1>
      <div class="grid grid-cols-3 gap-4 pl-4">
        <div v-for="image in banquetHallImages" :key="image.name" class="overflow-hidden">
          <img :src="image.url" :alt="`Conference Hall Image ${image.name}`" class="w-full h-auto px-4 py-8">
        </div>
      </div>
      </div>
    </Layout>
  </template>
  
  <script>

  import Layout from './../layouts/LayoutView.vue'
  import axiosInstance from '@/utils/axiosInstance';

  export default {
    components: {
      Layout
    },
    data() {
    return {
        banquetHallImages: [],
    };
  },
  computed: {
  },
  async created() {
    try {
      const response = await axiosInstance.get('home-page?populate[serviceLinkList][populate]=linkMedia'); 
      var responseAttributes = response.data.data.attributes;
      this.banquetHallImages = responseAttributes.serviceLinkList
        .filter(item => item.linkUrl === '/banquet-hall')
        .map(item => item.linkMedia.data[0].attributes);


    } catch (error) {
      console.error('Failed to fetch About Us Page:', error);
      
    }
  },
}
  </script>
    